import axios from "@/lib/axios";

export type RemoveEvidenceByIdRequestParams = {
  companyId: string;
  quizId: string;
  responseId: string;
  evidenceId: string;
};

export type RemoveEvidenceByIdResponse = void;

export const removeEvidenceById = (params: RemoveEvidenceByIdRequestParams) =>
  axios
    .delete<RemoveEvidenceByIdResponse>(
      `/v1/companies/${params.companyId}/application-quizzes/${params.quizId}/responses/${params.responseId}/evidences/${params.evidenceId}`,
    )
    .then(({ data }) => data);
